module.exports = __webpack_public_path__ + "static/media/special-events.5669b702.png";